import { fromJS } from 'immutable';
import * as ACTIONS from  '../containers/constants';

const initialState = fromJS({});

export function citiesReducer(state = initialState, action) {

  switch (action.type) {
    case ACTIONS.CRYODEX_UPDATE_CITIES:
    return {
      ...state,
      data: action.payload,
    };
    default:
      return state;
  }
}
 
export default citiesReducer;
